import { render, staticRenderFns } from "./AuthorityManagement.vue?vue&type=template&id=570ee57d&scoped=true&"
import script from "./AuthorityManagement.vue?vue&type=script&lang=js&"
export * from "./AuthorityManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ee57d",
  null
  
)

export default component.exports